import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "@environments/environment";
import { RequestHelper } from "@helper/request.helper";
import { InquiryService } from "../services/kredivo.service";

@Component({
    selector: 'app-kredivo-inquiry',
    templateUrl : './kredivoinquiry.component.html',
    styleUrls: ['./kredivoinquiry.component.css']
})
export class KredivoInquiryComponent implements OnInit{

    form: FormGroup;
    isSubmitted: boolean;
    hostname: any = environment.hostName;
    imgUri : string;
    successPage: number;
    bindingInvoiceNumber : string;
    bindingAmount: string;
    redirectUri: string;
    pageSide: string;

    constructor(private router:Router, private inquiryService:InquiryService,
        private dataQuery: ActivatedRoute,
        private apiService:RequestHelper){
        this.isSubmitted = false
        this.successPage = 0
        this.pageSide = "N";
        /** init data from other page */
        this.bindingAmount = this.dataQuery.snapshot.paramMap.get('totalAmount') == "undefined" ? localStorage.getItem('amoun') : this.dataQuery.snapshot.paramMap.get('totalAmount');
        this.bindingInvoiceNumber = this.dataQuery.snapshot.paramMap.get('idOrder') == "undefined" ? localStorage.getItem('invoice') : this.dataQuery.snapshot.paramMap.get('idOrder');
        console.log("id order -> ",this.bindingInvoiceNumber);
        console.log("total amount -> ",this.bindingAmount); 
    }

    ngOnInit(): void {
        this.imgUri = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/financing/kredivo.png';
        this.form = new FormBuilder().group({
            invoiceNumber: [this.bindingInvoiceNumber, [Validators.required]],
            amount: [this.bindingAmount, [Validators.required]],
            otp: [null, [Validators.required]]
        })
        /** call get id */
        console.log("invoice from localstorage -> "+localStorage.getItem('invoice'));
        this.inquiryService.getOrderId(this.bindingInvoiceNumber)
        .subscribe(data => {
            console.log("get order id : "+JSON.stringify(data));
            console.log("url callback : "+JSON.stringify(data.back_to_store_uri));
            this.redirectUri = data.back_to_store_uri;
        },e => console.log("error because "+e))
    }

    previousPage(){
        this.router.navigate(['/paylater-kredivo']);
    }

    paymentDone(){
        console.log("payment done click");
        window.location.href=this.redirectUri;
    }

    doInquiry(){
        console.log("otp => "+JSON.stringify(this.form.controls["otp"].value))
        if (this.form.controls["otp"].value != "00000"){
            console.log("payment error because otp not match");
            localStorage.setItem('invoice', this.bindingInvoiceNumber);
            localStorage.setItem('amoun', this.bindingAmount);
            this.openDialog("Wrong OTP Value");
        }else{
            var requestBody = {
                "orderId" : this.bindingInvoiceNumber,
                "type": "success"
            }
            console.log("data request : => ",requestBody)
            this.inquiryService.notifPayment(requestBody).subscribe(data => {
                if (data.status == "OK" && data.message != "bill already paid"){
                    console.log("success payment");
                    console.log("response : ",data);
                    this.successPage=1;
                    this.pageSide="Y";
                }else if (data.status == "OK" && data.message == "bill already paid"){
                    console.log("payment is already paid");
                    console.log("response : ",data);
                    this.successPage=0;
                    this.pageSide="N";
                    this.openDialog("Payment Already Paid");
                }else{
                    this.successPage=0;
                    this.pageSide="N";
                    this.openDialog("Payment Failed");
                }
            }, error => console.log("error payment from be"))
        }   
    }

    openDialog(result){
        this.apiService.openDialog(result, 'kredivo/payment');
    }
}
